module.exports = __webpack_public_path__ + "static/img/finpro_logo.e13782a.png";


//////////////////
// WEBPACK FOOTER
// ./static/ibcoinexx/img/backend/finpro_logo.png
// module id = /Y3j
// module chunks = 22